<template>
  <van-popup
    v-model="show"
    class="customer"
    round
    position="bottom"
    :style="{ height: '90%' }"
  >
    <div class="title border-bottom">
      <van-icon name="arrow-down" @click="show = false" />
      <span>选择客户</span>
      <van-button size="small" @click="$router.push({ name: 'CreateCustomer' })">创建客户</van-button>
    </div>
    <div class="content">
      <van-search
        show-action
        autofocus
        clearable
        v-model="value"
        placeholder="搜索姓名或者手机号"
        @search="onSearch"
      >
        <template #action>
          <van-button @click="onSearch" size="small">搜索</van-button>
        </template>
      </van-search>
      <van-cell-group>
        <template v-if="customerList && customerList.length">
          <van-cell
            v-for="item in customerList"
            :key="item.id"
            :title="item.customerName"
            :value="item.customerTel || '--'"
            @click="handleClick(item)"
          />
        </template>
        <span class="no-data" v-else>暂无数据</span>
      </van-cell-group>
    </div>
  </van-popup>
</template>

<script>
import { getCustomerList } from '@/api/customer'
export default {
  name: 'CustomerPopup',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      value: '',
      customerList: []
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onSearch() {
      const numReg = /^[0-9]+$/
      const params = {}
      if (!numReg.test(this.value)) {
        Object.assign(params, {
          customerName: this.value || undefined
        })
      } else {
        Object.assign(params, {
          customerTel: this.value || undefined
        })
      }
      this.getList(params)
    },
    handleClick(item) {
      this.show = false
      this.$emit('select-item', item)
    },
    getList(params = {}) {
      getCustomerList({ page: 1, count: 50, ...params }).then((res) => {
        if (res.errcode === 0) {
          this.customerList = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.customer {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    font-size: 14px;
    .van-button { height: 24px; background-color: transparent; color: #F59A23; border: none; font-size: 14px; }
  }
  .content {
    height: calc(~'100% - 48px');
    .van-cell-group { height: calc(~'100% - 54px'); overflow: auto; }
  }
  .no-data { color: #333; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
}
</style>